/**
 * Sprout design system tokens.
 * Mirrors the CSS custom properties in src/index.css and the theme used by
 * documentcollectorfe so the showroom looks like the components it documents.
 */

export const fontFamily = "'Manrope', sans-serif";
export const monoFontFamily = "'JetBrains Mono', 'Fira Code', Menlo, Consolas, monospace";

export const radius = {
  small: 2,
  medium: 4,
  large: 8,
  xLarge: 16,
  circle: 9999,
};

export const elevation = {
  xSmall: '0 1px 2px rgba(0,0,0,0.08)',
  small: '0 2px 4px rgba(0,0,0,0.10)',
  medium: '0 4px 8px rgba(0,0,0,0.12)',
  large: '0 8px 16px rgba(0,0,0,0.14)',
};

const light = {
  primary: '#447952',
  onPrimary: '#FFFFFF',
  primaryContainer: '#F4FFE0',
  onPrimaryContainer: '#152F1A',
  primaryHovered: '#24462A',
  primaryPressed: '#152F1A',

  background: '#F9F9F9',
  surface: '#FFFFFF',
  surfaceVariant: '#E5E5E5',
  surfaceHovered: '#F2F2F2',
  onSurface: '#1A1A1A',
  supportingText: '#595959',
  outline: '#CCCCCC',
  outlineSubtle: '#E5E5E5',
  disabled: '#A6A6A6',

  success: '#119754',
  successContainer: '#C2F8DD',
  warning: '#BF9C0C',
  warningContainer: '#FFF4C2',
  danger: '#E1563B',
  dangerContainer: '#FFE1DA',
  info: '#1B87BC',
  infoContainer: '#D7F0FC',
  link: '#9676B8',

  codeBackground: '#1A1A1A',
  codeHeader: '#262626',
  codeText: '#F2F2F2',
};

// Sprout is light-first; the dark set keeps the same hues with adjusted luminance.
const dark = {
  ...light,
  primary: '#8BC79A',
  onPrimary: '#0E2213',
  primaryContainer: '#1F3324',
  onPrimaryContainer: '#DDF5C4',
  primaryHovered: '#A6D9B2',
  primaryPressed: '#6FAE80',

  background: '#121412',
  surface: '#1B1E1B',
  surfaceVariant: '#2A2E2A',
  surfaceHovered: '#242824',
  onSurface: '#F2F2F2',
  supportingText: '#B3B3B3',
  outline: '#3A3F3A',
  outlineSubtle: '#2A2E2A',
  disabled: '#666666',

  successContainer: '#123A26',
  warningContainer: '#3A3212',
  dangerContainer: '#41201A',
  infoContainer: '#12303F',

  codeBackground: '#0B0D0B',
  codeHeader: '#161916',
};

export const colors = { light, dark };

export const getColors = (mode) => (mode === 'dark' ? dark : light);
